/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { useHistory, withRouter } from "react-router"
import * as wjRInput from "@grapecity/wijmo.react.input"
import * as wjInput from "@grapecity/wijmo.input"
import RootContainer from "./RootContainer"
import { ReactComponent as MenuIcon } from "./source/img/icons/menu.svg"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "."

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { clearAlert } from "./globalStore/alertStore"

// Kairos
import LogoMark from "./source/img/logomark.png"
import { getToday, get休日List } from "./globalStore/dateStore"
import { faClock, faUser } from "@fortawesome/free-regular-svg-icons"
import dateUtil from "./ts/util/dateUtil"
import SideBar from "./sideBar"
import { RootState } from "./globalStore/rootreducer"
import { logout } from "./globalStore/authStore"
import {
  faCaretDown,
  faCog,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons"

const Main = () => {
  const history = useHistory()

  const dispatch: AppDispatch = useDispatch()
  const [collapsed, setCollapsed] = useState(false)
  const [wjMenu, setWjMenu] = useState<wjInput.Menu>()

  const { progress: isProgress } = useSelector((state: RootState) => state)
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  useEffect(() => {
    dispatch(clearAlert())
  }, [history.location])

  // メニュー・営業日取得
  useEffect(() => {
    dispatch(getToday())
    dispatch(get休日List())
    const getTodayInterval = setInterval(() => {
      dispatch(getToday())
    }, 30 * 60 * 1000)
    return () => {
      clearInterval(getTodayInterval)
    }
  }, [])

  const menuInitialized = (menu: wjInput.Menu) => {
    setWjMenu(menu)
  }

  return (
    <div id="primaryContainer">
      <header>
        {/* メニュー開閉ボタン */}
        <div id="menuCollapseButton" onClick={() => setCollapsed(!collapsed)}>
          <MenuIcon id="headerMenuIcon" className={"menu-icon"} />
        </div>
        {/* ヘッダーの情報部 */}
        <div id="headerInformation">
          <div id="headerCompanyInformation">
            <img src={LogoMark} alt="" className="header-logomark" />
            <span>大川運輸 Kairos</span>
          </div>

          <div id="headerUserSettings">
            <span className={"env-name-text align-middle"}>
              {process.env.REACT_APP_ENVIRONMENT_NAME}
            </span>
            <span style={{ marginRight: "2rem" }}>
              <FontAwesomeIcon
                className="align-middle"
                icon={faClock}
                size={"1x"}
              />
              <span style={{ marginLeft: ".5rem" }}>最終操作時刻</span>
              <span style={{ marginLeft: ".5rem" }}>
                {dateUtil.getNowString()}
              </span>
            </span>
            <div
              className="align-middle d-inline-block"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                wjMenu?.show(e.currentTarget)
              }}>
              <FontAwesomeIcon
                className="align-middle"
                icon={faUser}
                size={"1x"}
              />
              <div className="align-middle d-inline-block ms-3">
                <div className="text-start w-100">{`${userInfo.営業所略称}　${userInfo.部所略称}`}</div>
                <div className="text-start w-100">{`${userInfo.社員コード}: ${userInfo.社員氏名}`}</div>
              </div>
              <FontAwesomeIcon
                className="align-middle ms-3"
                icon={faCaretDown}
                size={"2x"}
              />
            </div>
            <wjRInput.Menu
              style={{ display: "none", margin: "0" }}
              className={"user-setting-menu"}
              initialized={menuInitialized}
              showDropDownButton={false}
              itemClicked={(e: wjInput.Menu) => {
                switch (e.selectedIndex) {
                  case 0:
                    history.push("/settings/password")
                    break
                  case 1:
                    //TODO: ダイアログは要調整
                    if (window.confirm("ログアウトしますか？")) {
                      try {
                        dispatch(logout())
                        history.push("/login")
                      } catch (error) {
                        history.push("/login")
                      }
                    }
                    break
                  default:
                    break
                }
              }}>
              <wjRInput.MenuItem>
                <FontAwesomeIcon icon={faCog} size={"1x"} />
                <span>設定</span>
              </wjRInput.MenuItem>
              <wjRInput.MenuItem>
                <FontAwesomeIcon icon={faSignOutAlt} size={"1x"} />
                <span>ログアウト</span>
              </wjRInput.MenuItem>
            </wjRInput.Menu>
          </div>
        </div>
      </header>
      {/* ページのボディ部 */}
      <div id="secondaryContainer">
        {/* サイドバー */}
        <SideBar collapsed={collapsed} />
        {/* 画面全体抑制用ローディング　制御はprogressStoreで行う */}
        <div
          className={
            isProgress ? "screen-spinner fade is-show" : "screen-spinner fade"
          }></div>
        {/* 各ページのコンポーネントをここに表示する */}
        <div id="rootContainer" className={collapsed ? "" : "menu-active"}>
          <div className={collapsed ? "menu-inactive" : "menu-active"}>
            <RootContainer />
          </div>
        </div>
      </div>
      {/* バックグラウンドの画像表示 */}
      <div id="background"></div>
    </div>
  )
}

export default withRouter(Main)
